export default __webpack_public_path__ + "static/media/slem.cd6ffa67.jpg";